import { AccessoryProductType } from 'data/types';
import { useLogManualAccessoryMutation } from 'features/api/project-api';
import { useCallback } from 'react';
import { resolveManualAccessoryLogAction } from 'utils/manual-accessories';
import type { ManualAccessoryEntryType } from 'utils/manual-accessories-types';

export function useManualAccessoryLogger(
  quotableSystemUniqueId: string | undefined
) {
  const [logManualAccessory] = useLogManualAccessoryMutation();

  return useCallback(
    (
      current: ManualAccessoryEntryType[],
      product: AccessoryProductType,
      quantity: number,
      ownerUniqueId?: string
    ) => {
      const action = resolveManualAccessoryLogAction(
        current,
        product.productId,
        quantity,
        ownerUniqueId
      );
      if (!action || !quotableSystemUniqueId) return;
      logManualAccessory({
        uniqueId: quotableSystemUniqueId,
        accessoryProductId: product.productId,
        quantity,
        action
      });
    },
    [logManualAccessory, quotableSystemUniqueId]
  );
}
